import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { getInitialCommonState } from '../common/commonInitialState';

export const loadInitialSalesDealerships = () => {
    return {
        ...getInitialCommonState(),
        availableDealerships: [],
        currentDealership: undefined,
        requestStatus: ApiRequestStatus.Idle
    };
};
